import { callAPI, HTTPMethod } from "./API";
import { LedgerAccounts, CostCenters } from "../model/LedgerAccountAndCostCenter";

export async function getCostCenters(tenantId: string, search: string, pageSize: number, offset: number, company: string, status?: string): Promise<CostCenters> {
    let query = {
        search: search,
        pageSize: pageSize.toString(),
        offset: offset.toString(),
        company: company
    } as Record<string, string>;

    if(status) {
        query = { ...query, status: status };
    }

    return await callAPI(`/tenants/${tenantId}/ledger/cost-centers`, {
        method: HTTPMethod.GET,
        query: query
    });
}

